"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var BetaTagWrapper = _styledComponents.default.div.withConfig({
  displayName: "BetaTag__BetaTagWrapper",
  componentId: "sc-1trehzo-0"
})(["display:flex;align-items:center;justify-content:center;width:fit-content;background-color:", ";border-radius:", ";"], _globalTokens.globalColor.background.secondary['1'], _globalTokens.globalBorder.radius['2']);
var BetaText = _styledComponents.default.div.withConfig({
  displayName: "BetaTag__BetaText",
  componentId: "sc-1trehzo-1"
})(["", ";padding:", " ", " ", " ", ";"], _tokens.default.sky.sys.font.label['1'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['200']);
var BetaTag = function BetaTag() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BetaTagWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BetaText, {
        children: "Beta"
      })
    })
  });
};
var _default = exports.default = BetaTag;